import * as Sentry from '@sentry/react';
import { ErrorInfo } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import './sentry.ts';

declare global {
  interface Window {
    Routerfy: any;
    __data: string;
    dataLayer: any;
  }
}

ReactDOM.createRoot(document.getElementById('root')!, {
  onRecoverableError: (error: unknown, errorInfo: ErrorInfo) => {
    Sentry.captureException(error, {
      extra: {
        errorInfo,
      },
    });
  },
}).render(
  <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
    <App />
  </Sentry.ErrorBoundary>
);
